/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../../Pages/AdminScreens/AllHolidays/AllHolidays.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { MdOutlineModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const AllHolidays = () => {
  const navigate = useNavigate();
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState();
  const [showSidebar, setShowSidebar] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [allHolidays, setAllHolidays] = useState([]);
  const [deleteItem, setDeleteItem] = useState(null);
  const LoginToken = GetToken();
  const [searchType, setSearchType] = useState("HolidayName");
  const GetAllHoliday = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Holiday/GetAllHoliday`,
    };
    axios(option)
      .then((e) => {
        setAllHolidays(JSON.parse(e?.data?.data));
        setLeaveRequestDuplicate(JSON.parse(e?.data?.data));
      })
      .catch(() => { });
  };
  useEffect(() => {
    GetAllHoliday();
  }, []);
  const handleDeleteHoliday = () => {
    const LoginToken = GetToken();
    const data = {};
    data.Id = deleteItem?.Id;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Holiday/DeleteHoliday`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          GetAllHoliday();
          setShowModal(false);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const handleshowHolidayModal = (item) => {
    setDeleteItem(item);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleDataSearch = (e) => {
  const searchTerm = e?.target?.value?.toLowerCase();

  if (searchTerm) {
    const filteredData = leaveRequestDuplicate?.filter((item) => {

      if (searchType === "HolidayName") {
        return item?.HolidayName?.toLowerCase()?.includes(searchTerm);
      }

      if (searchType === "Date") {
        return moment(item?.FromDate)
          .format("DD MMM YYYY")
          .toLowerCase()
          .includes(searchTerm);
      }

      return false;
    });

    setAllHolidays(filteredData);
  } else {
    setAllHolidays(leaveRequestDuplicate);
  }
};
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);
  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <div
            className={
              showSidebar
                ? "main-container-of-all-employees-Attendance-Holiday"
                : "main-container-of-all-employees-page-new-Attendance-management"
            }
          >
            <div className="inner-container-of-all-employees-page-Holiday ">
              <div className="header-of-employees-page-Holiday row">
                <div className="all-employee-Attendance-Holiday col">
                  <h4>All Holiday</h4>
                </div>
                <div className="all-employees-Attendance-Holiday col">
                  <div className="home-icon-Attendance-Holiday">
                    <BiHomeAlt className="home-icon-header-Attendance-Holiday" />
                  </div>
                  <div className="arrow-icon-Attendance-Holiday">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="employee-text-Attendance-Holiday">
                    <p>Holiday </p>
                  </div>
                  <div className="arrow-icon-Attendance-Holiday">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="all-employee-text-Attendance-Holiday">
                    <p>All Holiday</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="body-part-outer-Attendance-Holiday">
              <div className="EMP-inner-body-container-of-employee-table row-12"
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 15px", backgroundColor: "white", borderRadius: "10px 10px 0 0" }}>
                <div className="first-side-in-body-header col-6"
                  style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                  <div className="EMP-employee-text-in-body">
                    <h2 style={{ margin: 0, fontSize: "17px", fontWeight: 600, color: "#5b626b" }}>Holidays</h2>
                  </div>
                  <div className="EMP-input-for-search-in-employee-body"
                    style={{ display: "flex", alignItems: "center", position: "relative" }}>
                    <select
                      className="EMP-search-dropdown"
                      value={searchType}
                      onChange={(e) => setSearchType(e.target.value)}
                      style={{
                        height: "38px", padding: "0 10px", border: "1px solid #ccc",
                        borderRight: "none", borderRadius: "4px 0 0 4px", fontSize: "13px",
                        color: "#555", backgroundColor: "#f9f9f9", outline: "none", cursor: "pointer"
                      }}
                    >
                      <option value="HolidayName">Holiday Name</option>
                      <option value="Date">Date</option>
                    </select>

                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <MdSearch style={{
                        position: "absolute", left: "8px", fontSize: "17px",
                        color: "#aaa", pointerEvents: "none", zIndex: 1
                      }} />
                      <input
                        type="text"
                        placeholder={`Search by ${searchType === "HolidayName" ? "holiday name" : "date"}`}
                        onChange={(e) => handleDataSearch(e)}
                        style={{
                          height: "38px", paddingLeft: "30px", paddingRight: "12px",
                          border: "1px solid #ccc", borderRadius: "0 4px 4px 0",
                          fontSize: "13px", color: "#555", outline: "none", minWidth: "200px"
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-in-all-emplyee-Attendance-Holiday">
                <table className="table-main-Attendance-Holiday">
                  <thead className="thead-main-Attendance-Holiday">
                    <tr className="row-12">
                      <th className="image-class-Holiday col-2 ">
                        Sr. no
                      </th>
                      <th className="image-class-Holiday col-2 ">
                        Holiday Name
                      </th>
                      <th className="image-class-Holiday col-2 ">Date</th>
                      <th className="image-class-Holiday col-2 ">Day</th>
                      <th className="image-class-Holiday-and-fix-onmobile-view col-2 ">Action</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-main-Attendance-Holiday">
                    {allHolidays?.length ? (
                      <>
                        {allHolidays
                          ?.sort(
                            (a, b) =>
                              new Date(a.FromDate).getTime() -
                              new Date(b.FromDate).getTime()
                          )
                          .map((item, index) => (
                            <tr key={index}>
                              <td>
                                {index + 1}
                              </td>
                              <td>{item?.HolidayName}</td>
                              <td>
                                <span>{moment(item?.FromDate).format("DD MMM YYYY")}</span></td>
                              <td>{item?.Days}</td>
                              <td className="edit-delete-Holiday">
                                <MdOutlineModeEdit
                                  className="handel-Edit-button"
                                  onClick={() =>
                                    navigate("/Adm/Holidays/AddHolidays", {
                                      state: { allHolidays: item },
                                    })
                                  }
                                />
                                <MdDelete
                                  className="delete-icon-all-leaves-Holiday"
                                  onClick={() => handleshowHolidayModal(item)}
                                />
                              </td>
                            </tr>
                          ))}
                      </>
                    ) : (
                      <>
                        <tr className="no-record-found-tr-dashboard">
                          <td colSpan="10">No record found</td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      </div>
      {showModal && (
        <div
          className="modal show edit-leaveModal"
          style={{ display: "block" }}
        >
          <Modal.Dialog>
            <Modal.Header closeButton onClick={handleCloseModal}>
              <Modal.Title>Delete holiday </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Holiday Name: {deleteItem?.HolidayName}</p>
              <p>Date: {deleteItem?.FromDate?.split("T")[0]}</p>
              <p>Day: {deleteItem?.Days}</p>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="Delete-modal-close-button"
                onClick={handleCloseModal}
              >
                Close
              </button>
              <button
                className="Delete-modal-delete-button"
                onClick={handleDeleteHoliday}
              >
                Delete
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </>
  );
};
export default AllHolidays;